<template>
  <div class="container cpo-header">
    <router-link :to="{ name: 'default' }"> <img src="/img/logo-2.png" /> </router-link>
    <v-spacer class="d-md-none" />
    <div class="cpo-menu">
      <router-link :to="{ name: nav.value }" v-for="(nav, i) in navs" :key="i">{{ $t(nav.text) }}</router-link>
    </div>
    <div class="cpo-langs">
      <template v-for="(lang, i) in languages">
        <a class="cpo-lang" :key="lang.value" @click="changeLocale(lang)">{{ lang.text }}</a>
        <span :key="`|_${i}`" v-if="i + 1 < languages.length">|</span>
      </template>
    </div>
    <v-btn class="cpo-nd-toggle" text @click="drawer = !drawer"><v-icon>mdi-menu</v-icon></v-btn>
    <v-navigation-drawer v-model="drawer" absolute temporary right width="160">
      <v-list>
        <v-list-item v-for="(nav, i) in navs" :key="i" link>
          <v-list-item-content>
            <v-list-item-title class="text-center">
              <router-link :to="{ name: nav.value }">{{ $t(nav.text) }}</router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { languages } from "@/i18n";

export default {
  data() {
    return {
      languages,
      drawer: null,
      navs: [
        { text: "nav.performance", value: "performance-index" },
        { text: "nav.about", value: "about-index" },
        { text: "nav.news", value: "news-index" },
        { text: "nav.hall", value: "hall" },
        { text: "nav.examination", value: "examination" }
      ]
    };
  },
  methods: {
    changeLocale(lang) {
      this.$i18n.locale = lang.value;
      this.$moment.locale(lang.value);
      window.localStorage.setItem("language", lang.value);
    }
  },
  created() {
    var locale = window.localStorage.getItem("language");
    this.$i18n.locale = locale;
    this.$moment.locale(locale);
  }
};
</script>

<style lang="scss">
.cpo-header {
  flex-wrap: nowrap;
  align-items: flex-end;
  margin-bottom: 12px;
  .cpo-menu {
    padding: 0 20px;
    display: none;
    flex: 1 0 0%;
    a {
      color: rgba(0, 0, 0, 0.8);

      padding: 4px 12px;
      margin: 0 24px;
      border-bottom: solid 2px transparent;
      &.router-link-active {
        color: #9a0000;
        border-bottom-color: currentColor;
      }
    }
  }
  .cpo-langs {
    font-size: 14px;
  }
  .cpo-nd-toggle.v-btn.v-size--default {
    display: flex;
    min-width: 36px;
    padding: 0;
  }
}
@media (min-width: 960px) {
  .cpo-header {
    .cpo-menu {
      display: flex;
      a {
        font-size: 22px;
        line-height: 1;
      }
    }
    .cpo-langs {
      font-size: inherit;
    }
    .cpo-nd-toggle.v-btn.v-size--default {
      display: none;
    }
  }
}
</style>
